import React, { useEffect, useState, useMemo, useRef } from 'react'
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import UploadModal from './components/UploadModal';
import { renderSalesPersonCell,renderLocationDetails } from './utils/cellRenderers';
import { useUnreadCountPolling } from './utils/useUnreadCountPolling';
import { useVisibleRowIds } from './utils/useVisibleRowIds';

const AssignedAds = ({ pickDesign, assignedDesigns, setassignedDesigns, totalassigned, settotalassigned, activechild, loader, currentPage, setCurrentPage, handlePageChange, getassignedDesigns, hasMore, onLoadMore, dateRange, setDateRange, adType, setAdType, search, setSearch}) => {

  const { visibleIds, rowRef } = useVisibleRowIds();
  const liveUnread = useUnreadCountPolling(assignedDesigns, "/user/designer/getUnreadCounts", {
    enabled: activechild === "assigned-Ads",
    visibleIds,
  });
  const sentinelRef = useRef(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedCreative, setSelectedCreative] = useState(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !onLoadMore || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) onLoadMore(); },
      { threshold: 0.1 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, assignedDesigns.length]);

  useEffect(() => {
    setCurrentPage(0);
  }, [activechild])


  const handleUploadClick = (creativeId, creativeType) => {
    setSelectedCreative({ id: creativeId, type: creativeType });
    setShowUploadModal(true);
  };

  const handleUploadSuccess = (result) => {
    // Refresh data as needed
    console.log('Upload successful:', result);
  };

  const handleUploadError = (error) => {
    console.error('Upload failed:', error);
  };

  // Handle click outside to close any open menus
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close any open menus when clicking outside
      const menus = document.querySelectorAll('[data-menu]');
      let clickedOutside = true;
      
      menus.forEach(menu => {
        if (menu.contains(event.target)) {
          clickedOutside = false;
        }
      });
      
      if (clickedOutside) {
        // Close any open menus
        // Add specific menu close logic here if needed
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="overflow-auto">
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Sales Person Details</th>
              {/* <th>Ad Creation Date</th> */}
              {/* <th>Brand</th> */}
              <th>Campaign Name</th>
              {/* <th>Start Date</th> */}
              <th>Location Details</th>
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              <th>Action</th>
            </tr>
          </thead>
            {(assignedDesigns.length > 0 && !loader) ? (assignedDesigns.map((rawRow, idx) => {
              const liveCount = liveUnread[rawRow.creative_id];
              const row = liveCount != null ? { ...rawRow, unread_count: liveCount, unreadCount: liveCount } : rawRow;
              const assign_time = alphaformatDateTime(row.assigndate);

              return (
              <tbody ref={rowRef(rawRow.creative_id)}>
                <tr key={idx} className="border-t">
                  <td>
                    {renderSalesPersonCell(row.sales_person,row)}
                  </td>
                  {/* <td>{row.brand_name}</td> */}
                  <td>{row.creative_name}</td>
                  {/* <td className="p-2">
                    <div className='font-bold'>{start_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                  </td> */}
                  {/* <td className="p-2">
                    <div className='font-bold'>{end_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{end_date.timeStr}</div>
                  </td> */}
                  <td>
                    {renderLocationDetails(row)}
                  </td>
                  <td>{row.ad_type}</td>
                  <td>{row.cst_name}</td>
                  <td>
                    <div className='font-bold'>{assign_time.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{assign_time.timeStr}</div>
                  </td>
                  <td>
                    <button className="bg-blue-600 text-white px-3 py-1 rounded"
                      onClick={() => {
                        pickDesign(row.creative_id);
                      }}>
                      Pick Ad
                    </button>
                  </td>
                </tr></tbody>
              )
            })) : (!assignedDesigns.length > 0 && !loader ) ? (<NoDataFound colspan="10" />)
          : (<TableLoader colspan="10"/>)}
        </table>
      </div>
      {hasMore && !loader && <div ref={sentinelRef} className="h-6 w-full" />}
      {loader && assignedDesigns.length > 0 && <div className="flex justify-center py-3"><div className="spinner-border text-primary" role="status" /></div>}
      <UploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        creativeId={selectedCreative?.id}
        creativeType={selectedCreative?.type}
      />
    </div>
  );
};
export default AssignedAds;